// extracted by css-extract-rspack-plugin
export default {"cls1":"JJHomePageSearch-cls1_WSV","cls2":"JJHomePageSearch-cls2_isg JJHomePageSearch-cls1_WSV"};